import Alert, { AlertColor } from "@mui/material/Alert";
import Box from "@mui/material/Box";

interface Props {
	noticeMessage: {
		type: AlertColor;
		message: string;
	};
}

const Notice = ({ noticeMessage }: Props) => {
	return (
		<Box sx={{ mt: 2, mb: 2 }}>
			<Alert severity={noticeMessage.type}>{noticeMessage.message}</Alert>
		</Box>
	);
};

export default Notice;
